import httpService from "./httpService";

export default {
  findById(id) {
    return httpService.get(`/hcMobimeetingRoom/${id}`);
  },
}



// WEBPACK FOOTER //
// ./src/services/hcMobimeetingRoomService.js